<template>
  <div id="modeles">
    <router-link to="/horaires">
      <img class="imgicon" src="img/back.png" />
    </router-link>
    <h2>Modèles</h2>
    <button @click="createTemplate()" class="btn btn-success mt-3 mb-3 btn-sm">
      <font-awesome-icon :icon="'plus'" />&nbsp;Créer un template
    </button>
    <div class="table-responsive">
      <table class="mt-3 table table-hover" v-if="templates.length > 0">
        <thead>
          <tr>
            <th scope="col">Nom</th>
            <th scope="col">Site</th>
            <th scope="col">Actions</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="template of templates" v-bind:key="template.id">
            <th scope="row">{{template.nom}}</th>
            <td>{{sitesById[template.id_site].nom}}</td>
            <td>
              <router-link
                style="color: white;"
                :to="`./modeles/${template.id}`"
                class="btn btn-warning mr-3 btn-sm"
              >
                <font-awesome-icon :icon="'pen'" />
              </router-link>
              <button class="btn btn-danger btn-sm" @click="deleteTemplate(template.id)">
                <font-awesome-icon :icon="'trash'" />
              </button>
            </td>
            <td>
              <a href="javascript:" class="ml-3" @click="generatePDF(template.id)">
                <img class="imgicon" src="img/pdf.png" /> Télécharger en PDF
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <h5 class="pt-5" v-else>Aucun modèle existant</h5>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import Swal from "sweetalert2";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000
});

export default {
  data() {
    return {
      templates: [],
      sites: [],
      sitesById: []
    };
  },
  async created() {
    this.$store.commit("setLoading", true);
    this.sites = (await api.getSites()).data.sites;
    for (let site of this.sites) {
      this.sitesById[site.id] = site;
    }
    this.loadTemplates();
    this.$store.commit("setLoading", false);
  },
  methods: {
    generatePDF(id) {
      api.pdf(`modele`, { id }, `modele`);
    },
    async loadTemplates() {
      this.templates = (await api.getTemplateList()).data.templates;
    },
    async deleteTemplate(id) {
      this.$store.commit("setLoading", true);
      let response = await api.deleteTemplate(id);
      this.$store.commit("setLoading", false);
      Toast.fire({
        type: response.code === 200 ? "success" : "error",
        text: response.message
      });
      this.loadTemplates();
    },
    createTemplate() {
      const options = [];
      for (let site of this.sites) {
        options[site.id] = site.nom;
      }
      Swal.mixin({
        input: "text",
        confirmButtonText: "Suivant &rarr;",
        showCancelButton: true,
        progressSteps: ["1", "2"]
      })
        .queue([
          {
            title: "Nom du modèle",
            input: "text"
          },
          {
            title: "A quel site s'adresse ce modèle?",
            input: "select",
            inputOptions: options
          }
        ])
        .then(async result => {
          if (result.value) {
            this.$store.commit("setLoading", true);
            let response = await api.createTemplate(
              result.value[0],
              result.value[1]
            );
            this.$store.commit("setLoading", false);
            Toast.fire({
              type: response.code === 200 ? "success" : "error",
              text: response.message
            });
            this.loadTemplates();
          }
        });
    }
  }
};
</script>